import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import FacetFilter from "./FacetFilter";
import { getClassNameFactory } from "../../utilities/classNames";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import FilterIcon from "./images/FilterIcon";
import ClearIcon from "./images/ClearIcon";

var FacetFilterManager = /*#__PURE__*/function (_Component) {
  _inherits(FacetFilterManager, _Component);

  var _super = _createSuper(FacetFilterManager);

  function FacetFilterManager(props) {
    var _this;

    _classCallCheck(this, FacetFilterManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getClassName", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      // Check if we're in desktop view (> 1024px)
      if (window.innerWidth > 1024 && _this.state.isOverlayVisible) {
        _this.setState({
          isOverlayVisible: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCategoryFilterChange", function (categoryId, optionId) {
      _this.setState(function (prevState) {
        var newAllCategories = prevState.allCategories.map(function (category) {
          if (category.id === categoryId) {
            return _objectSpread(_objectSpread({}, category), {}, {
              options: category.options.map(function (option) {
                if (option.id === optionId) {
                  return _objectSpread(_objectSpread({}, option), {}, {
                    selected: !option.selected
                  });
                }

                return option;
              })
            });
          }

          return category;
        });
        var newSelectedFiltersByCategory = {};
        newAllCategories.forEach(function (category) {
          newSelectedFiltersByCategory[category.name] = category.options.filter(function (opt) {
            return opt.selected;
          });
        });
        return {
          allCategories: newAllCategories,
          selectedFiltersByCategory: newSelectedFiltersByCategory
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getTotalSelectedCount", function () {
      var allCategories = _this.state.allCategories;
      var count = 0;

      if (allCategories) {
        allCategories.forEach(function (category) {
          if (category.options) {
            category.options.forEach(function (option) {
              if (option.selected) {
                count++;
              }
            });
          }
        });
      }

      return count;
    });

    _defineProperty(_assertThisInitialized(_this), "clearFilters", function () {
      _this.setState(function (prevState) {
        var clearedAllCategories = prevState.allCategories.map(function (category) {
          return _objectSpread(_objectSpread({}, category), {}, {
            options: category.options.map(function (option) {
              return _objectSpread(_objectSpread({}, option), {}, {
                selected: false
              });
            })
          });
        });
        var newSelectedFiltersByCategory = {};
        clearedAllCategories.forEach(function (category) {
          newSelectedFiltersByCategory[category.name] = []; // All categories will have empty selected options
        });
        return {
          allCategories: clearedAllCategories,
          selectedFiltersByCategory: newSelectedFiltersByCategory
        };
      });
    });

    _this.state = {
      allCategories: _this.initializeCategories(props.filterData),
      selectedFiltersByCategory: {},
      isOverlayVisible: false
    };
    _this.getClassName = getClassNameFactory(FacetFilterManager.displayName);
    return _this;
  }

  _createClass(FacetFilterManager, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.filterData !== this.props.filterData) {
        this.setState({
          allCategories: this.initializeCategories(this.props.filterData),
          selectedFiltersByCategory: {} // Reset when filterData changes

        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "initializeCategories",
    value: function initializeCategories(filterData) {
      if (!filterData || !filterData.categories) {
        return [];
      }

      return filterData.categories.map(function (category) {
        return {
          id: category.id,
          name: category.name,
          options: category.options.map(function (opt) {
            return _objectSpread(_objectSpread({}, opt), {}, {
              selected: false
            });
          })
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          filterHeader = _this$props.filterHeader,
          filterSubHeader = _this$props.filterSubHeader,
          clearFilterText = _this$props.clearFilterText,
          applyFilterBtnText = _this$props.applyFilterBtnText;
      var _this$state = this.state,
          allCategories = _this$state.allCategories,
          isOverlayVisible = _this$state.isOverlayVisible;
      var totalSelectedCount = this.getTotalSelectedCount();

      if (!allCategories || allCategories.length === 0) {
        return null;
      }

      var filterContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "header"
        })
      }, /*#__PURE__*/React.createElement("span", {
        "data-testid": "filter-count",
        className: this.getClassName({
          descendantName: "filter-count"
        })
      }, filterHeader, " (", totalSelectedCount, ")"), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "title-row"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "title"
        })
      }, filterSubHeader), /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "clear-filters"
        }),
        onClick: this.clearFilters,
        role: "button",
        "data-testid": "clear-filters",
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter" || e.key === " ") {
            _this2.clearFilters();
          }
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "clear-icon"
        })
      }, /*#__PURE__*/React.createElement(ClearIcon, null)), clearFilterText))), /*#__PURE__*/React.createElement("div", {
        className: className
      }, allCategories.map(function (category) {
        return /*#__PURE__*/React.createElement(FacetFilter, {
          key: category.id,
          categoryTitle: category.name,
          categoryId: category.id,
          initialOptions: category.options,
          handleOptionChange: _this2.handleCategoryFilterChange
        });
      })), " ");
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "filter-button"
        }),
        onClick: function onClick() {
          return _this2.setState({
            isOverlayVisible: true
          });
        },
        "aria-label": "Open filters"
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "filter-icon"
        })
      }, /*#__PURE__*/React.createElement(FilterIcon, null)), filterHeader, " (", totalSelectedCount, ")"), isOverlayVisible ? /*#__PURE__*/React.createElement("div", {
        "data-testid": "facet-filter-overlay",
        className: "".concat(this.getClassName({
          descendantName: "overlay"
        }), " visible")
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "overlay-content"
        })
      }, /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "close-button"
        }),
        onClick: function onClick() {
          return _this2.setState({
            isOverlayVisible: false
          });
        },
        "aria-label": "Close filters"
      }, /*#__PURE__*/React.createElement(CrossIcon, {
        width: 16,
        height: 16
      })), filterContent, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "overlay-footer"
        })
      }, /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "apply-button"
        }),
        onClick: function onClick() {
          return _this2.setState({
            isOverlayVisible: false
          });
        },
        "data-testid": "apply-filters"
      }, applyFilterBtnText)))) : /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "desktop-view"
        })
      }, filterContent));
    }
  }]);

  return FacetFilterManager;
}(Component);

_defineProperty(FacetFilterManager, "displayName", "FacetFilterManager");

_defineProperty(FacetFilterManager, "defaultProps", {
  className: ""
});

export default FacetFilterManager;